var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('RouterView',{staticClass:"pb-15"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }